<template>
  <div class="template-main" :class="[{ 'none-height': clearHeight }, {'insurance': $route.name === 'admin-buy-insurance'}]">
    <template v-if="$route.meta.need_alive">
      <transition name="fade-transform" mode="out-in">
        <keep-alive>
          <router-view />
        </keep-alive>
      </transition>
    </template>
    <template v-else>
      <transition name="fade-transform" mode="out-in">
        <router-view />
      </transition>
    </template>
  </div>
</template>
<script>
export default {
  data() {
    return {
      clearHeight: false,
    };
  },
  watch: {
    $route(newValue, oldValue) {
      if (
        newValue.name === "distributor-train-front-home" ||
        newValue.name === "distributor-train-front-pay-success"
      ) {
        this.clearHeight = true;
      } else {
        this.clearHeight = false;
      }
    },
  },
  created() {
    if (
      this.$route.name === "distributor-train-front-home" ||
      this.$route.name === "distributor-train-front-pay-success"
    ) {
      this.clearHeight = true;
    } else {
      this.clearHeight = false;
    }
  },
};
</script>
<style lang="less" scoped>
@import "~@/common-style/variable.less";
.template-main {
  // min-height: 100vh;
  &.insurance{
    background-color: @main-bg-color;
  }
  &.none-height {
    min-height: auto;
  }
}
</style>

